import { render, staticRenderFns } from "./BankRemitItemListView.vue?vue&type=template&id=2abe5feb&scoped=true&"
import script from "./BankRemitItemListView.vue?vue&type=script&lang=ts&"
export * from "./BankRemitItemListView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abe5feb",
  null
  
)

export default component.exports